import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum LockKeyDeviceTypeId {
  CARD = 1,
  ALFRED_KEY = 3,
  PIN = 4,
}

export class LockKeyDeviceType extends Codebook<LockKeyDeviceTypeId> {
  static readonly CARD = new LockKeyDeviceType(LockKeyDeviceTypeId.CARD, () => $t('Card'))
  static readonly ALFRED_KEY = new LockKeyDeviceType(LockKeyDeviceTypeId.ALFRED_KEY, () =>
    $t('Alfred key'),
  )
  static readonly PIN = new LockKeyDeviceType(LockKeyDeviceTypeId.PIN, () => $t('PIN'))

  private constructor(
    id: LockKeyDeviceTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
